import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersWeeklyReportsEmployeeConditionSurveyProgressesIndexResponseType,
  ApiManagersWeeklyReportsEmployeeConditionSurveyProgressesIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersWeeklyReportsEmployeeConditionSurveyProgressesIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiManagersWeeklyReportsEmployeeConditionSurveyProgressesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersWeeklyReportsEmployeeConditionSurveyProgressesIndexResponseType>(
      "/api/managers/weekly_reports/employee_condition_survey_progresses",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersWeeklyReportsEmployeeConditionSurveyProgressesIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersWeeklyReportsEmployeeConditionSurveyProgressesIndex =
  ({
    params,
    config = {},
  }: PropsType = {}): UseQueryResult<ApiManagersWeeklyReportsEmployeeConditionSurveyProgressesIndexResponseType> => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
      ...config,
      queryKey: [
        "ApisManagersWeeklyReportsEmployeeConditionSurveyProgressesIndex",
        params,
      ],
      queryFn: () => request({ params }),
    });
  };
